import { toValue, useTemplateRef } from 'vue'

/**
 *
 * @param prefix {string|null|undefined} - Optional prefix for the saving indicator keys
 * @returns {{savingIndicatorKey: string, savingIndicatorTopKey: string, runSavingIndicator: function, stopSavingIndicator: function}} - An object containing the saving indicator keys and functions to control the saving indicator
 */
export const useSavingIndicator = (prefix = '') => {
  const _prefix = toValue(prefix) ? `${toValue(prefix)}-` : ''

  const savingIndicatorKey = `${_prefix}savingIndicator`
  const savingIndicatorTopKey = `${_prefix}savingIndicatorTop`

  const savingIndicatorReference = useTemplateRef(savingIndicatorKey)
  const savingIndicatorTopReference = useTemplateRef(savingIndicatorTopKey)

  const runSavingIndicator = () => {
    savingIndicatorReference.value?.startSaving()
    savingIndicatorTopReference.value?.startSaving()
  }

  const stopSavingIndicator = () => {
    savingIndicatorReference.value?.endSaving()
    savingIndicatorTopReference.value?.endSaving()
  }

  return {
    savingIndicatorKey,
    savingIndicatorTopKey,
    runSavingIndicator,
    stopSavingIndicator
  }
}
